module.exports = __webpack_public_path__ + "static/media/dispensing_vector_small.f22a39c5.png";